// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ExpiredRoundSvg from '@rsuite/icon-font/lib/status/ExpiredRound';
var ExpiredRound = createSvgIcon({
  as: ExpiredRoundSvg,
  ariaLabel: 'expired round',
  category: 'status',
  displayName: 'ExpiredRound'
});
export default ExpiredRound;